import {useEffect, useState} from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import { is } from 'immutable';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import {isNotEmpty, toAbsoluteUrl} from '../../../../../_metronic/helpers/index'
import { Auth, Storage } from 'aws-amplify';
import uuid from 'react-native-uuid';


const AWS_BUCKET_URL = process.env.REACT_APP_AWS_BUCKET_URL

type Props = {
    toggleShow:any,
    isUpdate: boolean,
    itemToEdit: any
}

const OrganizationAddModal: React.FC<Props> = ({toggleShow, isUpdate, itemToEdit}) => {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState(isUpdate ? itemToEdit:{'id': undefined,'name':'','branch_limit':0, 'status':1, 'logo':''});
  const [logo, setLogo] = useState('');
  const [templogo, setTempLogo] = useState(isUpdate ? itemToEdit.logo : '');
  const [errName, setErrName] = useState(false)
  const [errLimit, setErrLimit] = useState(false)
  const [errPhoto, setErrPhoto] = useState(false)


  useEffect(() => {
    console.log(itemToEdit)
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleSubmit = async (e : any) => {

  e.preventDefault();
  setErrLimit(false);
  setErrName(false);
  setErrPhoto(false);
  setIsSubmitting(true);
  try 
  {
    console.log(formData);

    var errFound = false;

    if(formData.name.trim() == ''){
      errFound = true;
      setErrName(true);
    }

    if(formData.branch_limit == ''){
      errFound = true;
      setErrLimit(true);
    }

    if(logo == '' && !isUpdate){
      errFound = true;
      setErrPhoto(true);
    }


    if(errFound){
      setIsSubmitting(false);
      return;
    }


    if(!isUpdate){
      // create process
      console.log(formData);
      
      const logofile:any = logo;
      const tempfile = logofile.name.split(".")
      const filename = uuid.v4() + '.' + tempfile[tempfile.length - 1];

      const file = await Storage.put(filename, logo);

      formData['logo'] = AWS_BUCKET_URL + filename;

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      await fetch(process.env.REACT_APP_API_URL_BACKEND + '/organization/create', 
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
    }
    else
    {

      console.log(formData);

      if(logo){
        const logofile:any = logo;
        const tempfile = logofile.name.split(".")
        const filename = uuid.v4() + '.' + tempfile[tempfile.length - 1];
  
        const file = await Storage.put(filename, logo);
  
        formData['logo'] = AWS_BUCKET_URL + filename;
      }

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      await fetch(process.env.REACT_APP_API_URL_BACKEND + '/organization/update', 
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
    }

    
    toggleShow();
  } 
  catch (error) 
  {
    console.log(error);
  }
};

const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const orgLogo = toAbsoluteUrl(`/media/${formData.logo}`)

const handleChange = (e : any) => {

  setFormData(
    {...formData, 
      [e.target.name]: e.target.value}
    );
};


const handleLogoChange = (event:any) => {
  setLogo(event.target.files[0]);
  setTempLogo(URL.createObjectURL(event.target.files[0]))
  console.log(URL.createObjectURL(event.target.files[0]))
};



  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'>
        <form id='kt_modal_add_permission_form' onSubmit={handleSubmit} className='form' noValidate>
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            {/* <UserEditModalHeader /> */}
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bold'>
              {isUpdate ? 'Update Organization' : 'Create Organization'}
              </h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={toggleShow}
                style={{cursor: 'pointer'}}>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>

            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {/* <UserEditModalFormWrapper /> */}
              
              
          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='d-block fw-semibold fs-6 mb-5'>Logo</label>
            {/* end::Label */}

            {/* begin::Image input */}
            <div
              className='image-input image-input-outline'
              data-kt-image-input='true'
              style={{backgroundImage: `url('${blankImg}')`}}
            >
              {/* begin::Preview existing avatar */}
              {
                templogo ? (
                  <div
                  className='image-input-wrapper h-125px'
                  style={{backgroundImage: `url('${templogo}')`}}
                >
                </div>
                ) : (
                  <div
                  className='image-input-wrapper h-125px'
                  style={{backgroundImage: `url('${blankImg}')`}}
                >
                </div>
                )
              }

              {/* end::Preview existing avatar */}

              {/* begin::Label */}
              { <label
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='change'
              data-bs-toggle='tooltip'
              title='Change avatar'
              >
              <i className='bi bi-pencil-fill fs-7'></i>

              <input type='file' name='logo' accept='.png, .jpg, .jpeg' onChange={handleLogoChange} />
              <input type='hidden' name='avatar_remove' />
            </label> }
              {/* end::Label */}

              {/* begin::Cancel */}
              { <span
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='cancel'
              data-bs-toggle='tooltip'
              title='Cancel avatar'
            >
              <i className='bi bi-x fs-2'></i>
            </span> }
              {/* end::Cancel */}

              {/* begin::Remove */}
              { <span
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='remove'
              data-bs-toggle='tooltip'
              title='Remove avatar'
            >
              <i className='bi bi-x fs-2'></i>
            </span> }
              {/* end::Remove */}
            </div>
            {/* end::Image input */}

            { errPhoto ?  <div className='form-text text-danger'>Logo is required.</div> : null}

            {/* begin::Hint */}
            { <div className='form-text'>Allowed file types: png, jpg, jpeg.</div> }
            {/* end::Hint */}
          </div>
          {/* end::Input group */}
              
              
              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}

                <input type="hidden" name="organization_id" value={formData ? formData.id: 0} />  
                
                <label className='required fw-semibold fs-6 mb-2'>Organization Name</label>                
                <input
                type='text'
                name='name'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.name : ''}
                />

                { errName ? <div className='form-text text-danger'>Name is required.</div> : null}
              </div>

              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}
                <label className='required fw-semibold fs-6 mb-2'>Branch Limit</label>                
                <input
                type='number'
                name='branch_limit'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData.branch_limit ? formData.branch_limit : 0}
                />
                { errLimit ? <div className='form-text text-danger'>Limit is required.</div> : null }
              </div>

              <div className='fv-row mb-7'>              
                <label className='required fw-semibold fs-6 mb-2'>Status</label>                
                <select onChange={handleChange} defaultValue={formData.status ? formData.status : 0} name='status' className='form-select form-select-solid form-select-lg fw-semibold'>
                  <option value='1' >Active</option>
                  <option value='0'>In-Active</option>
                </select>
              </div>



              <button
                type='reset'
                onClick={() => toggleShow(0)}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
                disabled={isSubmitting}
              >
                Cancel
              </button>

              <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              disabled={isSubmitting}>
              <span className='indicator-label'>{isUpdate ? 'Update' : 'Save'}</span>
              </button>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
        </form>      
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {OrganizationAddModal}
